import { useScroll, useTransform, motion } from "framer-motion"
import { useTheme } from "../../../theme/ThemeProvider"

export function HowItWorksBackground() {
  const { scrollYProgress } = useScroll()
  const { theme } = useTheme()

  const demonColors = [
    "#0a0a0b", // Hero: Near black
    "#0f0608", // Transition to hell
    "#1a0508", // Problem: Blood red/black
    "#2d0a0f", // Deep hell
    "#1a0a10", // Transition out of hell
    "#0f0a0b", // Solution: Dark with hope
    "#0a0a0b", // Architecture: Clean dark
    "#0a0a0b", // Footer
  ]

  const fairyColors = [
    "#0a0a0b", // Hero: Near black
    "#0a0d10", // Transition
    "#0d1318", // Problem: Deep blue
    "#101820", // Deep chaos
    "#0d1318", // Transition
    "#0a0d10", // Solution
    "#0a0a0b", // Clean dark
    "#0a0a0b", // Footer
  ]

  const colors = theme === "demon" ? demonColors : fairyColors

  const backgroundColor = useTransform(scrollYProgress, [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.7, 1], colors)

  const overlayOpacity = useTransform(scrollYProgress, [0, 0.15, 0.25, 0.4, 0.5], [0, 0.2, 0.4, 0.3, 0.1])

  const overlayColor = theme === "demon" ? "rgba(255, 43, 79, 0.15)" : "rgba(20, 184, 166, 0.15)"

  return (
    <>
      <motion.div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor,
          zIndex: -2,
        }}
        aria-hidden="true"
      />

      <motion.div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `radial-gradient(ellipse at 50% 100%, ${overlayColor} 0%, transparent 70%)`,
          opacity: overlayOpacity,
          zIndex: -1,
          pointerEvents: "none",
        }}
        aria-hidden="true"
      />
    </>
  )
}
